import React from 'react';

const Letter = () => {
    return (
        <div className="relative pb-16  overflow-hidden">
            {/* Light blue wave */}
            <div className="absolute bottom-0 h inset-0 z-0">
                <div className="w-full bottom-0 overflow-hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1432 525" fill="none" preserveAspectRatio="xMidYMid slice">
                        <g filter="url(#filter0_f_599_408)">
                            <path d="M603 37.182C499.8 54.794 181.167 26.5665 -5 5.12165L-25 1523.5H1508.5L1560 60.0515C1490.67 45.9452 1316.4 15.21 1174 5.12165C996 -7.48875 732 15.1672 603 37.182Z" fill="#85ADE1" fillOpacity="0.5" />
                        </g>
                        <defs>
                            <filter id="filter0_f_599_408" x="-28" y="0" width="1591" height="1525" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_599_408" />
                            </filter>
                        </defs>
                    </svg>
                </div>
            </div>

             

            {/* Dark blue wave */}
            <div className="absolute inset-x-0 bottom-0 z-10">
                <div className="w-full overflow-hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="300" viewBox="0 0 1432 150" fill="none" preserveAspectRatio="xMidYMax slice">
                        <path d="M450 77.999C350.665 90.4305 143.195 79.136 -36 63.999V1099.5H1440.07V63.999C1373.34 54.0415 1247.38 18.6223 1112 5.74981C830.901 -20.9785 636.5 54.659 450 77.999Z" fill="#012A47" />
                    </svg>
                </div>
            </div>

             {/* Content */}
             <div className="relative z-20  max-w-7xl mx-auto p-4">
                <div className=" bg-white  rounded-md shadow-4xl  p-8" style={{ boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.3), 0 5px 10px rgba(0, 0, 0, 0.1)' }}>
                    <div className='max-w-3xl mx-auto'>
                    <div className='w-full flex flex-col justify-center items-center'>
                    <div className="w-52 h-2 bg-[#003366] my-8"></div>

                    </div>

                    <h1 className="text-xl font-semibold text-center mb-6 underline decoration-1">
                        Please read the following message carefully:
                    </h1>

                    <div className="space-y-6 text-center">
                        <p className="text-gray-800">
                            Thank you for your order. Your order is being processed and will be sent to the warehouse for shipping in the next{" "}
                            <span className="font-semibold">48 hours.</span>
                        </p>

                        <p className="text-gray-800">
                            Most orders will ship to their destination in{" "}
                            <span className="font-bold">3-5 business days.</span>
                        </p>

                        <p className="text-gray-800">
                            You will receive a notification once your order is shipped.
                        </p>

                        <p className="text-gray-800">
                            Please check that you used the correct email address.
                        </p>

                        <p className="text-gray-800">
                            For any questions regarding your order, you can contact our customer support department at{" "}
                            <a
                                href="mailto:support@herbalteatherapy.com"
                                className="text-blue-600 hover:text-blue-800 underline"
                            >
                                support@herbalteatherapy.com
                            </a>{" "}
                            quoting your order number.
                        </p>
                    </div>
                    </div>

                 
                </div>
            </div>

          
        </div>
    )
};

export default Letter;



